import { render, staticRenderFns } from "./DevTreeMenu.vue?vue&type=template&id=2d7ff320&scoped=true"
import script from "./DevTreeMenu.vue?vue&type=script&lang=js"
export * from "./DevTreeMenu.vue?vue&type=script&lang=js"
import style0 from "./DevTreeMenu.vue?vue&type=style&index=0&id=2d7ff320&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ff320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7ff320')) {
      api.createRecord('2d7ff320', component.options)
    } else {
      api.reload('2d7ff320', component.options)
    }
    module.hot.accept("./DevTreeMenu.vue?vue&type=template&id=2d7ff320&scoped=true", function () {
      api.rerender('2d7ff320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Handover/DevTreeMenu.vue"
export default component.exports